// src/components/Dashboard/CompletionTimeCard.tsx
import React from "react";
import { ClockCircleOutlined, PercentageOutlined } from "@ant-design/icons";

interface CompletionTimeCardProps {
  avgCompletionDays: number;
  totalCompleted: number;
  totalFolders: number;
}

const CompletionTimeCard: React.FC<CompletionTimeCardProps> = ({
  avgCompletionDays,
  totalCompleted,
  totalFolders,
}) => {
  const completionRate =
    totalFolders !== 0 ? (totalCompleted / totalFolders) * 100 : 0;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-center">
          <div className="rounded-full bg-blue-100 p-3 mr-3">
            <ClockCircleOutlined className="text-blue-500 text-xl" />
          </div>
          <div>
            <div className="text-gray-500 text-sm">
              Tiempo Promedio para Completar
            </div>
            <div className="text-xl font-bold text-gray-800">
              {avgCompletionDays === 0
                ? "N/A"
                : `${avgCompletionDays.toFixed(1)} días`}
            </div>
          </div>
        </div>

        <div className="flex items-center">
          <div className="rounded-full bg-green-100 p-3 mr-3">
            <PercentageOutlined className="text-green-500 text-xl" />
          </div>
          <div>
            <div className="text-gray-500 text-sm">Folders Completados</div>
            <div className="text-xl font-bold text-gray-800">
              {`${Math.round(completionRate)}%`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletionTimeCard;
